<div class="flex-vertical width-100pc gap-8">
  <div class="body-1">Type de démembrement<span class="color-error">*</span></div>

  <oui-slide-toggle
    label="Démembrement"
    [(checked)]="dismemberedChecked"
  (checkedChange)="onDemembrementToggled()"></oui-slide-toggle>
  @if (dismemberedChecked) {
    <oui-button-toggle [options]="dismemberedOptions" [control]="dismemberedControl"></oui-button-toggle>
    <div class="flex-vertical width-100pc gap-8">
      @if (!isViager) {
        <div class="top-margin-8">Contrepartie connue ? <span class="color-error">*</span></div>
      }
      <div class="flex-horizontal width-100pc gap-32">
        @if (!isViager) {
          <oui-button-toggle
            [options]="contrepartieOptions"
            [control]="contrepartieControl"
          class="flex-1"></oui-button-toggle>
        }
        @if (isKnown || isViager) {
          <oui-textfield
            label="Nom de la contrepartie"
            type="text"
            [control]="contrepartieNameControl"
          class="flex-1"></oui-textfield>
        }
        @if (!isKnown || isViager) {
          <div class="flex-1"></div>
        }
      </div>
    </div>
  }
</div>
